import React, {Component} from 'react'
import { Form, FormGroup, Label, Input, Button, Table, Card, CardBody, Col, Tooltip } from 'reactstrap';
import { reduxForm } from 'redux-form'
import InputField from '../Inputs/InputField'
import Select  from '../Inputs/Select'
import CompaniesTable from '../CompaniesTable'
import SearchCompanyValidator from '../../validators/SearchCompany'
import { withTranslation, Trans } from "react-i18next";

class AddCompany extends Component{

  constructor(props) {
	  super(props);
  }
  
  
  render(){
	  const fields = ["name", "fiscal_code", "piva", "address", "city", "province_code"]
	  const {search_result, createCompany, handleSubmit, searchCompanies, t} = this.props
	  return (
	    <Card>
		    <CardBody>
		      <div>
			      <Form onSubmit={handleSubmit(searchCompanies)}>
			        <FormGroup row>
				        <Col xs="2">
				          <Select name="country" options={["AF","AL","AS","AO","AM","AU","AT","AZ","BH","BD","BY","BE","BJ","BA","BW","BR","BG","BF","BI","KH","CM","CA","CV","CF","TD","CL","CN","CO","CD","HR","CZ","CI","DK","DJ","EC","EG","GQ","ER","EE","ET","FI","FR","GA","GM","GE","DE","GH","GR","GU","GN","GW","HK","HU","IS","IN","IE", "IT","JP","JO","KZ","KE","XK","KW","KG","LA","LV","LB","LS","LR","LI","LT","LU","MK","MG","MW","MY","ML","MT","MH","MR","MU","YT","MX","FM","MD","ME","MA","MZ","MM","NA","NP","NL","NZ","NE","NG","MP","NO","OM","PK","PW","PS","PL","PT","PR","QA","RO","RU","RW","RE","SH","ST","SA","SN","RS","SC","SL","SG","SK","SI","SO","ZA","KR","ES","LK","SD","SZ","SE","CH","SY","TW","TJ","TZ","TH","TG","TR","TM","UG","UA","AE","GB","US","UZ","VE","VN","VI","EH","YE","ZM","ZW"].map((c) => ({value: c, name: t(`country_iso_code.${c}`)})).sort((a,b) =>  {return a.name > b.name ? 1 : -1})} />
				        </Col>
				        <Col>
				          <InputField name="name" placeholder="Name or identification number" />
				        </Col>
				        <Col xs="auto">
				          <Button type="submit">
					          {search_result && search_result.status=='REQUESTED' ? <i className="fa fa-spinner fa-spin"></i> : null}
					          {search_result && search_result.status=='ERROR' ? <i className="fa fa-exclamation-triangle" ></i> : null}
					          
					          
					          <Trans>add_company.search</Trans>
				          </Button>
				        </Col>	
			        </FormGroup>
			      </Form>
			      
			      {search_result && search_result.result ? <CompaniesTable createCompany={createCompany} companies={(search_result && search_result.result && search_result.result.data ? search_result.result.data : [])} /> : null}
		      </div>
		    </CardBody>
	    </Card>
	  )
  }
}
export default withTranslation()(reduxForm({
  form: 'searchCompaniesForm',
  enableReinitialize: true,
  destroyOnUnmount: false,
  validate: SearchCompanyValidator
})(AddCompany))
